var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarthquake1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 110",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-earthquake-7278785",
    transform: "translate(-5.355 -14.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    d: "M53.1,90.6l8.4,5.3L59.8,108l-8,0.5l-2.1-27.7c-0.2-5.4-4.7-9.7-10.1-9.5s-9.7,4.7-9.5,10.1 c0,0.3,0,0.6,0.1,0.9l2.1,27.6L22,110.8l-3.4-44.2L53.4,41l-2,26.8l7.6,2.9L53.1,90.6z M64.4,43.9l38,23.2v44.3H62.2l4.9-15.2 l-8.9-5.5L67.5,71l-7-2.8L64.4,43.9z M83.8,84.1H94V73.9H83.8V84.1z M83.8,97.8H94V87.5H83.8V97.8z M70.1,84.1h10.2V73.9H70.1V84.1 z M70.1,97.8h10.2V87.5H70.1V97.8z M54.4,27.7L10.3,60.2c-2,1.3-2.5,3.9-1.2,5.9c1.3,2,3.9,2.5,5.9,1.2c0.1-0.1,0.2-0.2,0.4-0.3 l38.2-28.1L54.4,27.7z M110.4,60.1L66.1,31.4l-1.4,9.1l41.2,26.8l0,0c0.7,0.4,1.5,0.7,2.3,0.7c2.4,0,4.3-1.9,4.3-4.3 C112.4,62.3,111.6,60.9,110.4,60.1L110.4,60.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthquake1);
export default __webpack_public_path__ + "static/media/earthquake-1.8fefa6402b5fae92bdce26e99b8b24e5.svg";
export { ForwardRef as ReactComponent };